import type { CappusBackendError } from './cappus-backend-error';
import type { CappusError } from './cappus-error';

export function parseBackendError({ status, error }: CappusBackendError): CappusError {
  return {
    status,
    message: error?.message,
    errors: error?.errors,
  };
}
